<template>
<div class="page-funreport">
	<img v-bind:src="sharereport.pic.replace('../', './')" style="display:none;">
	<!-- 趣味报告标题 -->
	<fun-head></fun-head>
	<!-- 趣味报告标题 -->
	<!-- 趣味报告 -->
	<fun-report></fun-report>
	<!-- 趣味报告 -->
	<!-- actions -->
	<div class="funreport-actions">
		<a class="btn" @click="goIndex()">我的动物画像</a>
		<a v-if="fromChannel==1" @click="gotoWz()" class="btn">更多精彩测试</a>
		<a v-else @click="gotoWz()" class="btn">专业爱情测评</a>
	</div>
	<!-- actions -->
	<yxl-logo></yxl-logo>

</div>
</template>

<script type="text/javascript">
import { mapState } from 'vuex'
import { mapMutations } from 'vuex'
// import { mapActions } from 'vuex'
// import $route from 'vue-router'
import axios from 'axios'
import APIS from '../apis.js'
import store from '../store.js'
import router from '../router.js'
import logo from '../components/yxl-logo.vue'
import funHeadShare from '../components/funHeadShare.vue'
import funBodyShare from '../components/funBodyShare.vue'
import qrcodeMask from '../components/qrcodeMask.vue'

export default {
	name: 'shareReportPage',
	components: {
		yxlLogo: logo,
		funHead: funHeadShare,
		funReport: funBodyShare,
		qrcodeMask: qrcodeMask
	},

	beforeRouteEnter (to, from, next){
		axios.get(APIS.sharereport, {
			params: {
				id: to.params.reportId
			}
		}).then(function(res) {
			var res = res.data;
			if(res.code==200) {
				store.commit('setShareReport', {report:res.data,gender:res.gender});
			} else if (res.code == 1001){
          //拿授权
			    window.location.href = APIS.shouquan + '?callback=' + encodeURIComponent(location.href);
      } else if(res.code = 400) {
				router.push({
					path: '/funreport',
					name: 'funreport'
				})
			}
		}).then(function() {
			next(vm => {
				console.log('load');
				// 统计外部渠道打开次数
				let fromChannel = vm.GetQueryString("fromChannel")?vm.GetQueryString("fromChannel"):1;
				if (fromChannel != 1) {
					console.log("fromChannel:" + fromChannel);
					zhuge.track('测评活动', {
				    '打开分享页渠道' : '外部渠道',
					});
				}
			});
		}).catch(function(error){
			console.log(error);
		})
	},
	computed: mapState({
		selfResult: state => state.selfResult,
		sharereport: state => state.sharereport,
		channel_id: state => state.channel_id,
		fromChannel() {
			return this.GetQueryString("fromChannel")?this.GetQueryString("fromChannel"):1;
		},
	}),
	mounted() {
		document.querySelector('.page-funreport').style.minHeight = window.screen.availHeight - 45 + 'px';

		document.title = '你是萌兽，还是猛兽？';

		// 微信分享
		let that = this;
		wx.ready(function() {
			wx.onMenuShareAppMessage({
				title: '天了噜，' + that.selfResult.nickname + ' 灵魂深处竟然是神兽' + that.sharereport.animal + '！', // 分享标题
				desc: '每个人身体里都有一只动物，代表着你最原始的兽性',
				link: 'http://static.xinli001.com/animalPicture/index.html?fromChannel=' + that.fromChannel + '#/sharereport/'+that.selfResult.activate_id + '?' + Math.random(), // 分享链接
				imgUrl: 'http://static.xinli001.com/animalPicture/'+ that.sharereport.pic.replace('../', ''), // 分享图标
				type: 'link', // 分享类型,music、video或link，不填默认为link
				dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
				success: function () {
          zhuge.track('测评活动', {
              '被分享页面' : '好友分享页',
          });
				},
				cancel: function () {
				  // 用户取消分享后执行的回调函数
				}
			});

      wx.onMenuShareTimeline({
        title: '天了噜，' + that.selfResult.nickname + ' 灵魂深处竟然是神兽' + that.sharereport.animal + '！', // 分享标题
        link: 'http://static.xinli001.com/animalPicture/index.html?fromChannel=' + that.fromChannel + '#/sharereport/'+that.selfResult.activate_id + '?' + Math.random(), // 分享链接
        imgUrl: 'http://static.xinli001.com/animalPicture/'+ that.sharereport.pic.replace('../', ''), // 分享图标
        success: function () {
          zhuge.track('测评活动', {
              '被分享页面' : '好友分享页',
          });
        },
        cancel: function () {
            // 用户取消分享后执行的回调函数
        }
      });

			wx.hideMenuItems({
		    menuList: [
					'menuItem:share:qq',
					'menuItem:share:weiboApp',
					'menuItem:share:QZone',
					"menuItem:openWithSafari",
					"menuItem:copyUrl"
		    ] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
			});
		});
		this.setShareFrom(this.$route.params.reportId)
	},
	methods: {
		...mapMutations([
			'setShareFrom',
			'setChannelId'
		]),
		goIndex() {
			router.push({
				name: 'index',
				path: '/index',
        query: {
          channel_id: this.channel_id
        }
			})
		},
		gotoWz() {
			if (this.fromChannel == 1) {
				zhuge.track('测评活动', {
			    '进入微站渠道' : '内部渠道',
				});
			} else {
				zhuge.track('测评活动', {
			    '进入微站渠道' : '外部渠道',
				});
			}
			window.location.href = 'http://' + this.selfResult.testurl;
		}
	}
}
</script>

<style scoped lang="scss">
$font-size-base:32; // Base on 320rem * 0.5;
@function topx($rem) {
  @return $rem/$font-size-base;
}
.page-funreport {
	position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background: url('../../static/images/all_bg.png');
	.funreport-actions {
		text-align: center;
		margin-top: topx(50rem * 0.5);
		margin-bottom: topx(110rem * 0.5);
		font-size: 0;
		.btn {
			display: inline-block;
			height: topx(60rem * 0.5);
			padding: 0 topx(24rem * 0.5);
			margin-right: topx(93rem * 0.5);
			font-size: topx(24rem * 0.5);
			color: #81600e;
			background: #edc96f;
			line-height: topx(62rem * 0.5);
			border-radius: topx(10rem * 0.5);
			border: topx(3rem * 0.5) solid #e6ae24;
			&:last-child {
				margin: 0;
			}
		}
		.unlockPeople {
			color: #868686;
			font-size: topx(22rem * 0.5);
		}
	}
}
</style>



// WEBPACK FOOTER //
// sharereport.vue?741ff08a